import { render } from "./office-select-area.vue?vue&type=template&id=4cb8ff53"
import script from "./office-select-area.vue?vue&type=script&lang=js"
export * from "./office-select-area.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__